import Cart from './pages/Cart/Cart';
import ClassSchedulingConfirmation from './pages/Confirmation/ClassSchedulingConfirmation';
import SingleCourse from './pages/Course/SingleCourse';
import Dashboard from './pages/Dashboard/Dashboard';
import ForParents from './pages/ForParents/ForParents';
import ForSchools from './pages/ForSchools';
import AddCourse from './pages/ForTutors/AddCourse';
import CreateLiveClass from './pages/ForTutors/CreateLiveClass';
import EditCourse from './pages/ForTutors/EditCourse';
import ForTutors from './pages/ForTutors/ForTutors';
import Lessons from './pages/ForTutors/Lessons';
import LiveClasses from './pages/ForTutors/LiveClasses';
import SingleLesson from './pages/ForTutors/SingleLesson';
import TutorDashboard from './pages/ForTutors/TutorDashboard';
import Home from './pages/Home/Home';
import LearnSection from './pages/Learn/LearnSection';
import SinglePaidCourse from './pages/Learn/SinglePaidCourse';
import TakeCourse from './pages/Learn/TakeCourse';
import TakeTutorCourse from './pages/Learn/TakeTutorCourse';
import TutorLearnSection from './pages/Learn/TutorLearnSection';
import Live from './pages/LiveClass/Live';
import Login from './pages/Login/Login';
import Payment from './pages/Payment/Payment';
import Profile from './pages/Profile/Profile';
import AllSchools from './pages/Schools/AllSchools';
import DashboardSingleSchool from './pages/Schools/DashboardSingleSchool';
import SingleSchool from './pages/Schools/SingleSchool';
import SearchResult from './pages/SearchResult/SearchResult';
import SelectSchool from './pages/SelectSchool/SelectSchool';
import StudentSignup from './pages/StudentSignup';
import SingleSubject from './pages/Subjects/SingleSubject';
import SingleTutor from './pages/Tutors/SingleTutor';
import Meeting from './pages/meeting/Meeting';
import MeetingIndex from './pages/meeting/MeetingIndex';

export const routes = [
  {
    id: 1,
    path: '/',
    component: Home,
  },
  {
    id: 2,
    path: '/select-subject',
    component: SelectSchool,
  },
  {
    id: 3,
    path: '/login',
    component: Login,
  },
  {
    id: 4,
    path: '/schools',
    component: ForSchools,
  },
  {
    id: 5,
    path: '/student-signup',
    component: StudentSignup,
  },
  {
    id: 6,
    path: '/parents',
    component: ForParents,
  },
  {
    id: 7,
    path: '/school-register',
    component: ForTutors,
  },
  {
    id: 8,
    path: '/dashboard',
    component: Dashboard,
  },
  {
    id: 9,
    path: '/subjects/:id',
    component: SingleSubject,
  },
  {
    id: 10,
    path: '/tutors/:id',
    component: SingleTutor,
  },
  {
    id: 11,
    path: '/learn/:subjectId/:schoolId',
    component: LearnSection,
  },
  {
    id: 12,
    path: '/tutor-learn/:subjectId/:schoolId',
    component: TutorLearnSection,
  },

  {
    id: 13,
    path: '/schools/:id',
    component: SingleSchool,
  },
  {
    id: 14,
    path: '/start/:subjectId/:schoolId',
    component: TakeCourse,
  },
  {
    id: 15,
    path: '/tutor-start/:subjectId/:schoolId',
    component: TakeTutorCourse,
  },
  {
    id: 16,
    path: '/profile',
    component: Profile,
  },
  {
    id: 17,
    path: '/live',
    component: Live,
  },
  {
    id: 18,
    path: '/confirmation',
    component: ClassSchedulingConfirmation,
  },
  {
    id: 19,
    path: '/result/:topic/:text',
    component: SearchResult,
  },
  {
    id: 20,
    path: '/tutor-dashboard',
    component: TutorDashboard,
  },
  {
    id: 21,
    path: '/add-lesson',
    component: AddCourse,
  },
  {
    id: 22,
    path: '/tutor/live-classes',
    component: LiveClasses,
  },
  {
    id: 23,
    path: '/tutor/courses',
    component: Lessons,
  },
  {
    id: 24,
    path: '/tutor/courses/:id',
    component: SingleLesson,
  },
  {
    id: 25,
    path: '/tutor/live-classes/create',
    component: CreateLiveClass,
  },
  {
    id: 26,
    path: '/cart',
    component: Cart,
  },

  {
    id: 27,
    path: '/view-schools/:id',
    component: DashboardSingleSchool,
  },

  {
    id: 28,
    path: '/courses/:id',
    component: SingleCourse,
  },
  {
    id: 29,
    path: '/payment',
    component: Payment,
  },
  {
    id: 30,
    path: '/update-course/:id',
    component: EditCourse,
  },
  {
    id: 31,
    path: '/view-subject/:id',
    component: SinglePaidCourse,
  },
  {
    id: 32,
    path: '/all-schools',
    component: AllSchools,
  },
  {
    id: 33,
    path: '/meeting',
    component: Meeting,
  },
  {
    id: 33,
    path: '/meeting-index',
    component: MeetingIndex,
  },
];
